/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_No_Folder_SelectedInputs */

const en_drastic_tech_no_folder_selected = /** @type {(inputs: Drastic_Tech_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No folder selected`)
};

const fr_drastic_tech_no_folder_selected = /** @type {(inputs: Drastic_Tech_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun dossier selectionne`)
};

const de_drastic_tech_no_folder_selected = /** @type {(inputs: Drastic_Tech_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Ordner ausgewählt`)
};

const it_drastic_tech_no_folder_selected = /** @type {(inputs: Drastic_Tech_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna cartella selezionata`)
};

const ru_drastic_tech_no_folder_selected = /** @type {(inputs: Drastic_Tech_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Папка не выбрана`)
};

const es_drastic_tech_no_folder_selected = /** @type {(inputs: Drastic_Tech_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ninguna carpeta seleccionada`)
};

const zh_cn2_drastic_tech_no_folder_selected = /** @type {(inputs: Drastic_Tech_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择文件夹`)
};

const ja_drastic_tech_no_folder_selected = /** @type {(inputs: Drastic_Tech_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダが選択されていません`)
};

const hi_drastic_tech_no_folder_selected = /** @type {(inputs: Drastic_Tech_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई फ़ोल्डर चयनित नहीं है`)
};

const pt_pt2_drastic_tech_no_folder_selected = /** @type {(inputs: Drastic_Tech_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma pasta selecionada`)
};

/**
* | output |
* | --- |
* | "No folder selected" |
*
* @param {Drastic_Tech_No_Folder_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_no_folder_selected = /** @type {((inputs?: Drastic_Tech_No_Folder_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_No_Folder_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_no_folder_selected(inputs)
	if (locale === "de") return de_drastic_tech_no_folder_selected(inputs)
	if (locale === "it") return it_drastic_tech_no_folder_selected(inputs)
	if (locale === "ru") return ru_drastic_tech_no_folder_selected(inputs)
	if (locale === "es") return es_drastic_tech_no_folder_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_no_folder_selected(inputs)
	if (locale === "ja") return ja_drastic_tech_no_folder_selected(inputs)
	if (locale === "hi") return hi_drastic_tech_no_folder_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_no_folder_selected(inputs)
	return en_drastic_tech_no_folder_selected(inputs)
});